import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './TemplateHeader6.module.css';
import { FaBars, FaTimes } from 'react-icons/fa';
import { useAuth } from '../../Common/Configurations/AuthContext';

const TemplateHeader6 = ({ branding, mode, templateId, headerMenu = [], onNavigate }) => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { user } = useAuth();

  const logoUrl = branding?.logoUrl || user?.logo;
  const companyName = branding?.companyName || user?.companyName || "Travel Agency";
  const brandName = branding?.brandName || user?.brandName || "Travel Agency";

  const handleNavClick = (e, item) => {
    const viewName = item.path === "/" ? "home" : item.path.replace('/', '');

    // BUILDER MODE
    if (mode === "builder") {
      e.preventDefault();
      onNavigate({ name: viewName, params: null });
    }
    // PREVIEW MODE
    else if (mode === "preview") {
      e.preventDefault();
      navigate(`/template-preview/${templateId}/${viewName}`);
    }
    // LIVE MODE
    else {
      // Let Link handle navigation normally
    }

    setIsMobileMenuOpen(false);
  };

  return (
    <header className={styles.header}>
      {/* Background Data Grid Overlay */}
      <div className={styles.gridOverlay}></div>

      <div className={styles.container}>
        
        {/* LOGO BOX */}
        <div className={styles.logoContainer}>
          <div className={styles.bracketTop}></div>

         <Link
  to="/"
  onClick={(e) => {
    e.preventDefault(); // 🔥 stops navigation
    handleNavClick(e, { path: "/" });
  }}
>
            {logoUrl ? (
              <img src={logoUrl} alt={brandName} className={styles.logoImage} />
            ) : (
              <h2 className={styles.textLogo}>{brandName}</h2>
            )}
          </Link>

          <div className={styles.bracketBottom}></div>
        </div>

        <div className={styles.rightSection}>

          <nav className={`${styles.nav} ${isMobileMenuOpen ? styles.navOpen : ''}`}>
            <ul className={styles.navList}>
              {headerMenu.map((item, index) => (
                <li key={item.id} className={styles.navItem}>
                  <Link
                    to={item.path}
                    onClick={(e) => handleNavClick(e, item)}
                    className={styles.navLink}
                  >
                    <span className={styles.coord}>0{index + 1}</span>
                    <span className={styles.label}>{item.label}</span>
                    <div className={styles.crosshair}></div>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className={styles.ctaContainer}>
            <button className={styles.bookBtn}>
              <span className={styles.btnPulse}></span>
              <span className={styles.btnText}>BOOKING</span>
            </button>
          </div>

          <div
            className={styles.mobileToggle}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
          </div>

        </div>
      </div>
    </header>
  );
};

export default TemplateHeader6;